// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonWrapper } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import Close from "@tps/XDL/Icons/Close";
import { xBaseTheme } from "@tps/XDL/types";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...TagPresentationPropsDefault,
        mergeCss: true,
        color: "primary",
        typographyProps: {
            size: 11,
            weight: "bold",
            color: "common.white",
            css: css`
                letter-spacing: 0;
                line-height: 15px;
                margin: 0;
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
            `,
        },
        iconProps: {
            size: 10,
            src: Close,
            css: css`
                &,
                svg {
                    width: 8px;
                }
            `,
        },
        css: css`
            padding: 3px 8px 5px;
            min-height: initial;
            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            margin: 0 8px 8px 0;
            border-radius: 0;
            &&& > ${ButtonWrapper} {
                order: -1;
                margin-right: 8px;
                margin-top: 3px;
                min-height: initial;
                background: transparent;
                flex-basis: 8px;
                svg path {
                    fill: ${color("common.white")};
                }
                &:hover > ${IconWrapper} {
                    opacity: 0.33;
                }
            }
        `,
    },
} as xBaseTheme["tag"];
